import { API_RESPONSE_CODE } from "@kivunova/kivufrontendcommon";
import { fetchGraphQL } from "../../../Graphql/utils";
import { getProductItemListQuery } from "../../../Graphql/querries/productItemQuery";
import {
  GetProductItemListRequest,
  GetProductItemListResponse
} from "../../../Graphql/types/productItem";
import { ProductItem } from "../types/products";

const PRODUCT_ITEM_PAGE_SIZE = 100;

export type FetchAllProductItemsOptions = Pick<
  GetProductItemListRequest,
  "nameSearch" | "storeId"
>;

/**
 * Loads every product-item row for summary stats.
 * Dedupes by id so a bad totalElements value cannot inflate counts.
 */
export const fetchAllProductItemsByProduct = async (
  productId: string,
  setAlert: (alert: unknown) => void,
  options?: FetchAllProductItemsOptions
): Promise<ProductItem[]> => {
  const byId = new Map<string, ProductItem>();
  let page = 0;
  let totalPages = 1;

  while (page < totalPages) {
    const input: Record<string, unknown> = {
      productId,
      pageSize: PRODUCT_ITEM_PAGE_SIZE,
      page
    };
    const nameSearch = options?.nameSearch?.trim();
    if (nameSearch) input.nameSearch = nameSearch;
    const storeId = options?.storeId?.trim();
    if (storeId) input.storeId = storeId;

    const response: GetProductItemListResponse = await fetchGraphQL(
      getProductItemListQuery,
      { input },
      setAlert
    );

    const result = response.listProductItemsByProduct;

    if (result.code !== API_RESPONSE_CODE.OK || !result.items) {
      break;
    }

    if (result.items.length === 0) {
      break;
    }

    for (const item of result.items) {
      if (item?.id) {
        byId.set(item.id, item);
      }
    }

    if (result.totalPages != null && result.totalPages >= 0) {
      totalPages = Math.max(1, result.totalPages);
    } else if (result.items.length < PRODUCT_ITEM_PAGE_SIZE) {
      break;
    }

    page += 1;
  }

  return Array.from(byId.values());
};
